// ═══════════════════════════════════════════════════════════════════════════════════════════════
// FAZ 6 — E-Belge Kontrol: paylaşılan model (enum → etiket/rozet + türetimler).
//
// ══ BU DOSYA EKRANIN TEK DOĞRULUK KAYNAĞIDIR ═══════════════════════════════════════════════════
// Grid rozeti, KPI şeridi ve drawer AYNI fonksiyonlardan beslenir. Aksi halde "Genel Durum" üç
// yerde üç kez yazılır ve zamanla ayrışırlar: grid "zarf hatası" derken KPI onu "servis hatası"
// sayar — kullanıcı hangisine güveneceğini bilemez.
//
// ══ ÜÇ EKSEN, ÜÇ AYRI KOLON ════════════════════════════════════════════════════════════════════
// Durum TEK ALAN DEĞİLDİR (spec §1). Her eksenin hatasının KAYNAĞI, ÇÖZENİ ve ÇÖZÜM YÖNTEMİ farklı:
//   1. Servis (transmission) → bağlantı/timeout   → BİT      → TEKRAR DENEMEK İŞE YARAR
//   2. GİB zarf (gib)        → BELGE İÇERİĞİ      → Muhasebe → TEKRAR DENEMEK İŞE YARAMAZ
//   3. Yanıt (response)      → alıcı müşteride    → Satış    → AKSİYON YOK, TELEFON
// Tek rozette birleştirmek "kimi arayacağım" sorusunu ekrandan siler.
// ═══════════════════════════════════════════════════════════════════════════════════════════════

// ── Belge tipi (backend: Static/ReturnStatuses.cs → EDocumentTypes). 1-TABANLI: ReturnHeader'da
//    canlı veri olduğu için 0'dan başlamıyor (Faz 4'ten devralındı, bilerek).
export const DOC_TYPE = { E_FATURA: 1, E_ARSIV: 2, E_IRSALIYE: 3 };

export const DOC_TYPE_OPTIONS = [
  { value: DOC_TYPE.E_FATURA, label: 'e-Fatura' },
  { value: DOC_TYPE.E_ARSIV, label: 'e-Arşiv' },
  { value: DOC_TYPE.E_IRSALIYE, label: 'e-İrsaliye' },
];
export const DOC_TYPE_LABEL = Object.fromEntries(DOC_TYPE_OPTIONS.map((o) => [o.value, o.label]));

// ── Senaryo. e-Arşiv ve e-İrsaliyede NULL — senaryo diye bir şey YOKTUR (kolonda `—`).
export const SCENARIO = { TEMEL: 0, TICARI: 1 };

export const SCENARIO_OPTIONS = [
  { value: SCENARIO.TEMEL, label: 'Temel' },
  { value: SCENARIO.TICARI, label: 'Ticari' },
];
export const SCENARIO_LABEL = Object.fromEntries(SCENARIO_OPTIONS.map((o) => [o.value, o.label]));

// ── Hareket tipi = belgeyi doğuran süreç (spec §5).
export const SOURCE_TYPE = {
  SALE: 0, VENDOR_RETURN: 1, SERVICE_INVOICE: 2, DELIVERY_NOTE: 3, TRANSPORT_WAYBILL: 4,
};

export const SOURCE_TYPE_OPTIONS = [
  { value: SOURCE_TYPE.SALE, label: 'Sıcak satış' },
  { value: SOURCE_TYPE.VENDOR_RETURN, label: 'Satıcıya iade' },
  { value: SOURCE_TYPE.SERVICE_INVOICE, label: 'Hizmet faturası' },
  { value: SOURCE_TYPE.DELIVERY_NOTE, label: 'Teslimat noktası' },
  // Taşıma irsaliyesi bugün PROJEKTE EDİLMİYOR (spec §11.1 açık sorusu) → listede hiç görünmez.
  // Filtre seçeneği yine de duruyor: açık soru yanıtlanıp projector'ın kapısı açıldığında
  // ekranın değişmesi gerekmesin diye.
  { value: SOURCE_TYPE.TRANSPORT_WAYBILL, label: 'Taşıma irsaliyesi' },
];
export const SOURCE_TYPE_LABEL = Object.fromEntries(SOURCE_TYPE_OPTIONS.map((o) => [o.value, o.label]));

// ═══════════════════════════════════════════════════ EKSEN 1 — SERVİS GÖNDERİMİ
// Hata kaynağı: bağlantı/timeout/auth. Çözen: BİT. TEKRAR DENEMEK İŞE YARAR.
export const TRANSMISSION = { QUEUED: 0, SENDING: 1, SENT: 2, FAILED: 3 };

export const TRANSMISSION_OPTIONS = [
  { value: TRANSMISSION.QUEUED, label: 'Kuyrukta' },
  { value: TRANSMISSION.SENDING, label: 'Gönderiliyor' },
  { value: TRANSMISSION.SENT, label: 'Gönderildi' },
  { value: TRANSMISSION.FAILED, label: 'Gönderilemedi' },
];
const TRANSMISSION_META = {
  [TRANSMISSION.QUEUED]: { label: 'Kuyrukta', tone: 'wait' },
  [TRANSMISSION.SENDING]: { label: 'Gönderiliyor', tone: 'neutral' },
  [TRANSMISSION.SENT]: { label: 'Gönderildi', tone: 'ok' },
  [TRANSMISSION.FAILED]: { label: 'Gönderilemedi', tone: 'bad' },
};

// ═══════════════════════════════════════════════════ EKSEN 2 — GİB / ZARF (BELGE İÇERİĞİ)
// Hata kaynağı: eksik VKN, yanlış referans. Çözen: MUHASEBE. TEKRAR DENEMEK İŞE YARAMAZ.
export const GIB = { NOT_SENT: 0, ENVELOPE_QUEUED: 1, PROCESSED: 2, ENVELOPE_ERROR: 3 };

export const GIB_OPTIONS = [
  { value: GIB.NOT_SENT, label: 'Gönderilmedi' },
  { value: GIB.ENVELOPE_QUEUED, label: 'Zarf kuyrukta' },
  { value: GIB.PROCESSED, label: 'İşlendi' },
  { value: GIB.ENVELOPE_ERROR, label: 'Zarf hatalı' },
];
const GIB_META = {
  [GIB.NOT_SENT]: { label: 'Gönderilmedi', tone: 'neutral' },
  [GIB.ENVELOPE_QUEUED]: { label: 'Zarf kuyrukta', tone: 'wait' },
  [GIB.PROCESSED]: { label: 'İşlendi', tone: 'ok' },
  [GIB.ENVELOPE_ERROR]: { label: 'Zarf hatalı', tone: 'bad' },
};

// ═══════════════════════════════════════════════════ EKSEN 3 — KARŞI TARAF YANITI
// Hata kaynağı: ALICI MÜŞTERİDE. Çözen: satış yöneticisi. AKSİYON YOK, TELEFON.
export const RESPONSE = {
  NOT_APPLICABLE: 0, AWAITING: 1, ACCEPTED: 2, REJECTED: 3,
  PARTIALLY_ACCEPTED: 4, AUTO_ACCEPTED_TIMEOUT: 5,
};

export const RESPONSE_OPTIONS = [
  { value: RESPONSE.NOT_APPLICABLE, label: 'Uygulanamaz' },
  { value: RESPONSE.AWAITING, label: 'Yanıt bekleniyor' },
  { value: RESPONSE.ACCEPTED, label: 'Kabul edildi' },
  { value: RESPONSE.REJECTED, label: 'Reddedildi' },
  { value: RESPONSE.PARTIALLY_ACCEPTED, label: 'Kısmi kabul' },
  { value: RESPONSE.AUTO_ACCEPTED_TIMEOUT, label: 'Süre doldu · otomatik kabul' },
];
const RESPONSE_META = {
  [RESPONSE.AWAITING]: { label: 'Yanıt bekleniyor', tone: 'wait' },
  [RESPONSE.ACCEPTED]: { label: 'Kabul edildi', tone: 'ok' },
  [RESPONSE.REJECTED]: { label: 'Reddedildi', tone: 'bad' },
  [RESPONSE.PARTIALLY_ACCEPTED]: { label: 'Kısmi kabul', tone: 'wait' },
  // SÜRE DOLDU = HATA DEĞİL. Fatura yasal olarak KABUL EDİLMİŞ sayılır → NÖTR rozet.
  // Kırmızı göstermek, yapılacak bir şey varmış gibi sahte aciliyet yaratırdı; yoktur.
  [RESPONSE.AUTO_ACCEPTED_TIMEOUT]: { label: 'Otomatik kabul', tone: 'neutral' },
};

// ── e-Arşiv'e özel: GÜNLÜK RAPOR bayrağı (iş kuralı 5). Zarf ekseninden BAĞIMSIZDIR.
export const ARCHIVE_REPORT = { NOT_APPLICABLE: 0, NOT_REPORTED: 1, REPORTED: 2 };

// ── Olay izi eksenleri (drawer zaman çizelgesi).
export const EVENT_AXIS = { TRANSMISSION: 0, GIB: 1, RESPONSE: 2, LIFECYCLE: 3 };
export const EVENT_AXIS_LABEL = {
  [EVENT_AXIS.TRANSMISSION]: 'Servis',
  [EVENT_AXIS.GIB]: 'GİB / Zarf',
  [EVENT_AXIS.RESPONSE]: 'Karşı taraf',
  [EVENT_AXIS.LIFECYCLE]: 'Yaşam döngüsü',
};

// ═══════════════════════════════════════════════════════════════════════════════════════════════
// UYGULANABİLİRLİK — "boş" ile "uygulanamaz" AYNI ŞEY DEĞİLDİR (spec §3)
// ═══════════════════════════════════════════════════════════════════════════════════════════════

/**
 * Bu belge tipi/senaryosu KARŞI TARAF YANITI BEKLER Mİ?
 *
 *   ticari e-Fatura → EVET (8 gün)      ·  e-İrsaliye → EVET (kısmi kabul dahil)
 *   temel  e-Fatura → HAYIR             ·  e-Arşiv    → HAYIR (alıcı mükellef değil)
 *
 * ⚠ İŞ KURALI 4: temel senaryo faturasında "yanıt bekleniyor" DİYE BİR ŞEY YOKTUR. O hücrede `—`
 * yazar. Sarı rozet göstermek YANLIŞ ALARMDIR — kullanıcı takip edilecek bir şey olduğunu sanır,
 * müşteriyi arar, karşı taraf "biz zaten yanıt vermiyoruz" der.
 */
export function expectsResponse(documentType, scenario) {
  if (documentType === DOC_TYPE.E_IRSALIYE) return true;
  if (documentType === DOC_TYPE.E_FATURA) return scenario === SCENARIO.TICARI;
  return false; // e-Arşiv
}

/**
 * Bir EKSEN bu belge için ANLAMLI MI? Anlamsızsa hücrede ROZET DEĞİL, `—` basılır.
 *
 * axis: 'transmission' | 'gib' | 'response' | 'scenario' | 'deadline'
 *
 * Eksen 1 (servis) ve eksen 2 (GİB) HER belge için anlamlıdır — hepsi bir şekilde GİB'e gider.
 * (e-Arşiv zarfla değil raporla gider ama "gönderildi mi" sorusu yine de geçerlidir.)
 */
export function isApplicable(axis, documentType, scenario) {
  switch (axis) {
    case 'transmission':
    case 'gib':
      return true;
    case 'scenario':
      // Senaryo YALNIZ e-Faturada vardır (temel/ticari). e-Arşiv ve e-İrsaliyede yoktur.
      return documentType === DOC_TYPE.E_FATURA;
    case 'response':
    case 'deadline':
      return expectsResponse(documentType, scenario);
    case 'archiveReport':
      // GÜNLÜK RAPOR yalnız e-Arşiv'de anlamlıdır (iş kuralı 5).
      return documentType === DOC_TYPE.E_ARSIV;
    default:
      return true;
  }
}

// ── Eksen rozeti: uygulanamazsa null döner (çağıran `—` basar).
export function transmissionBadge(row) {
  return TRANSMISSION_META[row.transmissionStatus] || null;
}

export function gibBadge(row) {
  // e-Arşiv ZARFLA GİTMEZ, GÜNLÜK RAPORLA gider (iş kuralı 5). Gönderilmiş ama rapora girmemiş
  // e-Arşiv belgesinde "İşlendi" demek YETMEZ ve YANILTICIDIR — rapor durumunu gösteriyoruz.
  if (row.documentType === DOC_TYPE.E_ARSIV
      && row.transmissionStatus === TRANSMISSION.SENT
      && row.archiveReportStatus === ARCHIVE_REPORT.NOT_REPORTED) {
    return { label: 'Rapora girmedi', tone: 'wait' };
  }
  return GIB_META[row.gibStatus] || null;
}

export function responseBadge(row) {
  // İŞ KURALI 4 — yanıtı olmayan belgede ROZET YOK. `—` basılır.
  if (!isApplicable('response', row.documentType, row.scenario)) return null;
  return RESPONSE_META[row.responseStatus] || null;
}

// ═══════════════════════════════════════════════════════════════════════════════════════════════
// GENEL DURUM — TÜRETİLMİŞ, SAKLANMAZ (iş kuralı 2)
// ═══════════════════════════════════════════════════════════════════════════════════════════════

/**
 * Üç eksenden TEK bir tarama rozeti türetir. Backend'de BÖYLE BİR KOLON YOKTUR ve olmamalıdır:
 * saklansaydı, üç eksenden biri değiştiğinde onu güncellemeyi unutan tek bir kod yolu, ekranı
 * sessizce yalan söyler hale getirirdi.
 *
 * ══ ÖNCELİK SIRASI = ACİLİYET SIRASI ═════════════════════════════════════════════════════════
 * Sıra keyfi değil: kullanıcının ÖNCE görmesi gereken, ÖNCE aksiyon alması gereken şeydir.
 *   1. Zarf hatası   → BELGE DÜZELTİLMELİ (muhasebe). Tekrar göndermek işe yaramaz.
 *   2. Servis hatası → TEKRAR DENENEBİLİR (BİT). Belge kusursuz olabilir.
 *   3. Reddedildi    → alıcı reddetti (satış).
 *   4. Kuyrukta / Gönderiliyor → henüz bizde.
 *   5. Kısmi kabul   → miktar kırılımına bakılmalı.
 *   6. Yanıt bekliyor → aciliyeti KALAN SÜREDEN gelir (ayrı kolon).
 *   7. Süre doldu    → aksiyon YOK (nötr).
 *   8. Tamam.
 *
 * Zarf hatasını servis hatasının ÜSTÜNE koymamızın sebebi: ikisi de "gönderilemedi" gibi görünür,
 * ama zarf hatası İNSAN müdahalesi olmadan ASLA çözülmez; servis hatası kendiliğinden düzelebilir.
 */
export function deriveOverallStatus(row) {
  if (!row) return { label: '-', tone: 'neutral' };

  if (row.gibStatus === GIB.ENVELOPE_ERROR) return { label: 'Zarf hatası', tone: 'bad' };
  if (row.transmissionStatus === TRANSMISSION.FAILED) return { label: 'Servis hatası', tone: 'bad' };
  if (row.responseStatus === RESPONSE.REJECTED) return { label: 'Reddedildi', tone: 'bad' };

  if (row.transmissionStatus === TRANSMISSION.QUEUED) return { label: 'Kuyrukta', tone: 'wait' };
  if (row.transmissionStatus === TRANSMISSION.SENDING) return { label: 'Gönderiliyor', tone: 'neutral' };

  // e-Arşiv: gönderildi ama GÜNLÜK RAPORA girmedi (iş kuralı 5). "Tamam" demek yanlış olurdu —
  // belge müşteriye ulaşmış olabilir ama GİB'in gözünde henüz raporlanmamıştır.
  if (row.documentType === DOC_TYPE.E_ARSIV
      && row.archiveReportStatus === ARCHIVE_REPORT.NOT_REPORTED
      && row.transmissionStatus === TRANSMISSION.SENT) {
    return { label: 'Raporsuz', tone: 'wait' };
  }

  if (row.responseStatus === RESPONSE.PARTIALLY_ACCEPTED) return { label: 'Kısmi kabul', tone: 'wait' };

  // Yanıt bekleniyor — YALNIZ yanıtı OLAN belgelerde (iş kuralı 4).
  if (row.responseStatus === RESPONSE.AWAITING
      && isApplicable('response', row.documentType, row.scenario)) {
    return { label: 'Yanıt bekliyor', tone: 'wait' };
  }

  // Süre doldu → otomatik kabul. AKSİYON YOK → nötr, kırmızı DEĞİL.
  if (row.responseStatus === RESPONSE.AUTO_ACCEPTED_TIMEOUT) {
    return { label: 'Süre doldu', tone: 'neutral' };
  }

  return { label: 'Tamam', tone: 'ok' };
}

// ═══════════════════════════════════════════════════════════════════════════════════════════════
// 8 GÜNLÜK SAYAÇ (spec §4)
// ═══════════════════════════════════════════════════════════════════════════════════════════════

/**
 * "Yanıt bekleniyor" TEK BAŞINA BİLGİ DEĞİLDİR. Bilgi, KAÇ GÜN KALDIĞIDIR.
 *
 * Eşikler:  > 3 gün → nötr  ·  ≤ 3 gün → SARI  ·  ≤ 1 gün → KIRMIZI  ·  süre doldu → nötr MAVİ
 *
 * Süre dolduğunda aciliyet BİTER (fatura otomatik kabul edilmiş sayılır, yapılacak bir şey yoktur)
 * — bu yüzden kırmızı değil nötr. Aciliyet süre DOLMADAN ÖNCEdir.
 *
 * Döner: { applicable, expired, days, label, tone }
 */
export function remainingDays(row, now = new Date()) {
  if (!row || !isApplicable('deadline', row.documentType, row.scenario) || !row.responseDeadlineAt) {
    return { applicable: false, expired: false, days: null, label: '—', tone: 'neutral' };
  }

  // Yanıt GELMİŞSE sayaç durmuştur — "3 gün kaldı" yazmak anlamsız olurdu.
  if (row.responseStatus !== RESPONSE.AWAITING) {
    if (row.responseStatus === RESPONSE.AUTO_ACCEPTED_TIMEOUT) {
      return { applicable: true, expired: true, days: 0, label: 'süre doldu', tone: 'neutral' };
    }
    return { applicable: false, expired: false, days: null, label: '—', tone: 'neutral' };
  }

  const deadline = new Date(row.responseDeadlineAt);
  if (Number.isNaN(deadline.getTime())) {
    return { applicable: false, expired: false, days: null, label: '—', tone: 'neutral' };
  }

  const msLeft = deadline.getTime() - now.getTime();
  if (msLeft <= 0) {
    // Süre dolmuş ama deadline job henüz koşmamış (günlük koşar). Ekran GERÇEĞİ gösterir.
    return { applicable: true, expired: true, days: 0, label: 'süre doldu', tone: 'neutral' };
  }

  const days = Math.ceil(msLeft / 86400000);
  const tone = days <= 1 ? 'bad' : days <= 3 ? 'wait' : 'neutral';
  return { applicable: true, expired: false, days, label: `${days} gün`, tone };
}

// ── Grid sıralaması için ham sayısal anahtar (varsayılan sıralama backend'de ResponseDeadlineAt).
export function deadlineSortKey(row) {
  if (!row?.responseDeadlineAt) return Number.MAX_SAFE_INTEGER;
  const t = new Date(row.responseDeadlineAt).getTime();
  return Number.isNaN(t) ? Number.MAX_SAFE_INTEGER : t;
}

// ═══════════════════════════════════════════════════════════════════════════════════════════════
// Biçimleyiciler
// ═══════════════════════════════════════════════════════════════════════════════════════════════

export function fmtDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: 'short' });
}

export function fmtDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('tr-TR', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export function fmtMoney(value) {
  if (value == null) return '—';
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency', currency: 'TRY', maximumFractionDigits: 2,
  }).format(Number(value) || 0);
}

/** Ekranda hangi aksiyonlar AKTİF? Backend de aynı kuralı uygular (kapı orada) — bu, UI kopyasıdır. */
export const canResend = (row) =>
  row?.transmissionStatus === TRANSMISSION.FAILED || row?.gibStatus === GIB.ENVELOPE_ERROR;

export const canQueryGib = (row) => row?.transmissionStatus === TRANSMISSION.SENT;

export const canCancel = (row) =>
  row?.transmissionStatus === TRANSMISSION.QUEUED || row?.transmissionStatus === TRANSMISSION.FAILED;

export const hasResponse = (row) =>
  [RESPONSE.ACCEPTED, RESPONSE.REJECTED, RESPONSE.PARTIALLY_ACCEPTED, RESPONSE.AUTO_ACCEPTED_TIMEOUT]
    .includes(row?.responseStatus);

/**
 * ⚠ Zarf hatasında `Tekrar Gönder` AKTİFTİR (kullanıcı belgeyi düzeltmiş olabilir) — ama bu bayrak
 * true ise ekran YANINA UYARI basar: "Belge içeriği düzeltilmeden tekrar gönderim aynı hatayı verir."
 * Butonu tamamen kapatmak, düzeltmeyi yapmış kullanıcıyı çaresiz bırakırdı.
 */
export const needsResendWarning = (row) => row?.gibStatus === GIB.ENVELOPE_ERROR;
